var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.273,
    height: 513.21,
    viewBox: "0 0 800.273 513.21",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-706.769 -271.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1227.483,688.357H448.611a10.542,10.542,0,0,1-10.53-10.53V195.42h799.932V677.827a10.541,10.541,0,0,1-10.53,10.53Z",
    transform: "translate(269.029 96.465)",
    fill: "#eef0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.4,644.108H464.2a10.656,10.656,0,0,1-10.645-10.644V236.184A10.657,10.657,0,0,1,464.2,225.54h733.2a10.656,10.656,0,0,1,10.644,10.644v397.28a10.656,10.656,0,0,1-10.644,10.645Z",
    transform: "translate(276.275 110.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.781,216.782H437.849v-24.64a10.542,10.542,0,0,1,10.53-10.53h778.872a10.542,10.542,0,0,1,10.53,10.53Z",
    transform: "translate(268.92 90)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.289,
    cy: 6.289,
    r: 6.289,
    transform: "translate(726.314 283.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.289,
    cy: 6.289,
    r: 6.289,
    transform: "translate(750.185 283.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.289,
    cy: 6.289,
    r: 6.289,
    transform: "translate(774.056 283.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(805.188 407.345)",
    fill: "#eef0f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(956.324 476.719)",
    fill: "#eef0f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(805.188 580.779)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(956.324 650.152)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(1332.923 684.839)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.568,
    height: 33.448,
    transform: "translate(1257.355 546.092)",
    fill: "#eef0f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.135,
    height: 33.448,
    transform: "translate(1031.892 546.092)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.135,
    height: 33.448,
    transform: "translate(1031.892 371.42)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.414,225.122V645.08H1209.09V225.122Zm753.2,34.79H1133.77V227.6h72.842ZM757.171,503.442V471.13H905.333v32.312Zm148.162,2.478v32.313H757.171V505.92Zm0-139.16v32.312H757.171V366.76Zm-148.162-2.478V331.97H905.333v32.313Zm0,69.58V401.55H905.333v32.313Zm148.162,2.478v32.313H757.171V436.34ZM754.694,399.072H681.852V366.76h72.842Zm0,2.478v32.313H681.852V401.55Zm0,34.79v32.313H681.852V436.34Zm0,34.79v32.312H681.852V471.13Zm153.117,0h72.842v32.312H907.81Zm0-2.478V436.34h72.842v32.313Zm0-34.79V401.55h72.842v32.313Zm0-34.79V366.76h72.842v32.312Zm0-34.79V331.97h72.842v32.313Zm0-34.79V297.18h72.842v32.313Zm-2.478,0H757.171V297.18H905.333Zm-150.639,0H681.852V297.18h72.842Zm0,2.478v32.313H681.852V331.97Zm-75.32,32.313H606.531V331.97h72.843Zm0,2.478v32.312H606.531V366.76Zm0,34.79v32.313H606.531V401.55Zm0,34.79v32.313H606.531V436.34Zm0,34.79v32.312H606.531V471.13Zm0,34.79v32.313H606.531V505.92Zm2.478,0h72.842v32.313H681.852Zm72.842,34.79v32.312H681.852V540.71Zm2.478,0H905.333v32.312H757.171Zm150.639,0h72.842v32.312H907.81Zm0-2.478V505.92h72.842v32.313Zm75.32-32.313h72.843v32.313H983.13Zm0-2.478V471.13h72.843v32.312Zm0-34.79V436.34h72.843v32.313Zm0-34.79V401.55h72.843v32.313Zm0-34.79V366.76h72.843v32.312Zm0-34.79V331.97h72.843v32.313Zm0-34.79V297.18h72.843v32.313Zm0-34.79V262.39h72.843V294.7Zm-2.478,0H907.81V262.39h72.842Zm-75.32,0H757.171V262.39H905.333Zm-150.639,0H681.852V262.39h72.842Zm-75.32,0H606.531V262.39h72.843Zm0,2.478v32.313H606.531V297.18Zm-75.321,32.313H531.211V297.18h72.842Zm0,2.478v32.313H531.211V331.97Zm0,34.79v32.312H531.211V366.76Zm0,34.79v32.313H531.211V401.55Zm0,34.79v32.313H531.211V436.34Zm0,34.79v32.312H531.211V471.13Zm0,34.79v32.313H531.211V505.92Zm0,34.79v32.312H531.211V540.71Zm2.478,0h72.843v32.312H606.531Zm72.843,34.79v32.313H606.531V575.5Zm2.478,0h72.842v32.313H681.852Zm75.32,0H905.333v32.313H757.171Zm150.639,0h72.842v32.313H907.81Zm75.32,0h72.843v32.313H983.13Zm0-2.478V540.71h72.843v32.312Zm75.321-32.312h72.842v32.312h-72.842Zm0-2.478V505.92h72.842v32.313Zm0-34.79V471.13h72.842v32.312Zm0-34.79V436.34h72.842v32.313Zm0-34.79V401.55h72.842v32.313Zm0-34.79V366.76h72.842v32.312Zm0-34.79V331.97h72.842v32.313Zm0-34.79V297.18h72.842v32.313Zm0-34.79V262.39h72.842V294.7Zm0-34.79V227.6h72.842v32.313Zm-2.478,0H983.13V227.6h72.843Zm-75.321,0H907.81V227.6h72.842Zm-75.32,0H757.171V227.6H905.333Zm-150.639,0H681.852V227.6h72.842Zm-75.32,0H606.531V227.6h72.843Zm-75.321,0H531.211V227.6h72.842Zm0,2.478V294.7H531.211V262.39ZM528.734,294.7H455.892V262.39h72.842Zm0,2.478v32.313H455.892V297.18Zm0,34.79v32.313H455.892V331.97Zm0,34.79v32.312H455.892V366.76Zm0,34.79v32.313H455.892V401.55Zm0,34.79v32.313H455.892V436.34Zm0,34.79v32.312H455.892V471.13Zm0,34.79v32.313H455.892V505.92Zm0,34.79v32.312H455.892V540.71Zm0,34.79v32.313H455.892V575.5Zm2.478,0h72.842v32.313H531.211Zm72.842,34.791V642.6H531.211V610.29Zm2.478,0h72.843V642.6H606.531Zm75.321,0h72.842V642.6H681.852Zm75.32,0H905.333V642.6H757.171Zm150.639,0h72.842V642.6H907.81Zm75.32,0h72.843V642.6H983.13Zm75.321,0h72.842V642.6h-72.842Zm0-2.478V575.5h72.842v32.313Zm75.32-32.313h72.842v32.313H1133.77Zm0-2.478V540.71h72.842v32.312Zm0-34.79V505.92h72.842v32.313Zm0-34.79V471.13h72.842v32.312Zm0-34.79V436.34h72.842v32.313Zm0-34.79V401.55h72.842v32.313Zm0-34.79V366.76h72.842v32.312Zm0-34.79V331.97h72.842v32.313Zm0-34.79V297.18h72.842v32.313Zm0-34.79V262.39h72.842V294.7ZM528.734,227.6v32.313H455.892V227.6ZM455.892,610.29h72.842V642.6H455.892ZM1133.77,642.6V610.29h72.842V642.6Z",
    transform: "translate(276.207 110.371)",
    fill: "#eef0f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsEmptyState);
export default __webpack_public_path__ + "static/media/materials-empty-state.e259f73c41792e5aa20ada098b35fdfd.svg";
export { ForwardRef as ReactComponent };